import { RouterState }     from '@ngrx/router-store';
import { ActionReducer }   from '@ngrx/store';
import { logoutCompleted } from './app.actions';
import {
  AppState,
  initialState,
}                          from './app.state';

export function logoutActionReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state: { app: AppState, router: RouterState }, action) {
    return reducer(action.type === logoutCompleted.type ? {
      app: {
        ...initialState,
        colorMode: state.app.colorMode,
        maintenanceMode: state.app.maintenanceMode,
      },
      router: state.router,
    } : state, action);
  };
}
